import {informationGatewayInterface} from "../../../corelogic/usecases/information/informationGatewayInterface";
import {TEnoField} from "../../../corelogic/models/entities/information/enoField";
import client from "../libs/client";

export default class APIInformationGateway implements informationGatewayInterface {
    error: any;


    setError = (error: boolean) => {
        this.error = error;
    };




    async getOperationInformation(operationId: number): Promise<TEnoField[][]> {
        let operationInformations: TEnoField[][] = []
        const {data: operation} = await client.get(`/operations/${operationId}`)
        operationInformations.push([{_type: 'name', _value: operation.name || '-', _editable: false}])
        operationInformations.push([{_type: 'dso', _value: operation.dso || '-', _editable: false}])
        operationInformations.push([{_type: `${operation.dso}.dsoOperationNumber` , _value: operation.dsoIdentifier || operation.enedisId || '-', _editable: false}])
        if (operation.legalRegion !== 'BRUXELLES') operationInformations.push([{_type: 'legalStatus', _value: operation.pmoLegalStatusId || '-', _editable: false}])
        operationInformations.push([{_type: 'address', _value: operation.pmoAddress || '-', _editable: false}])
        operationInformations.push([{_type: 'city', _value: operation.pmoCity || '-', _editable: false}])
        operationInformations.push([{_type: 'postCode', _value: operation.pmoPostCode || '-', _editable: false}])
        operationInformations.push([{_type: 'representantName', _value: operation.representativeName || '-', _editable: false}])
        operationInformations.push([{_type: 'representantPhone', _value: operation.representativePhoneNumber|| operation.pmoPhoneNUmber || '-', _editable: false}])
        operationInformations.push([{_type: 'representantEmail', _value: operation.representativeEmail || operation.pmoEmail || '-', _editable: false}])
        return operationInformations
    }
}
